import React, { useEffect } from 'react';

import { InfoMessage } from '@eika/attention-message';
import { IconTypes } from '@eika/icon';
import { Link, LinkType } from '@eika/link';

import { StringKeyValue } from '../../../actions/types';
import { ApplicationReducer } from '../../../reducers/application';
import InfoBox from '../../Messages/InfoBox';
import ProductImage from '../../ProductImage/ProductImage';

interface Props {
    application: ApplicationReducer;
    returnLink: string;
    text: StringKeyValue;
}

const SummaryDeclined = ({ application, text, returnLink }: Props): JSX.Element => {
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, []);

    const {
        summaryTitleDeclined,
        summaryTextDeclined1,
        summaryTextDeclined2,
        summaryReturnButtonDeclined,
        summaryInfoBoxDeclined,
        summaryInfoBoxDeclinedFrozen,
    } = text;

    return (
        <div className="summary-declined">
            <>
                {summaryTitleDeclined && (
                    <ProductImage className="summary-declined__header" image="Stop" title={summaryTitleDeclined} />
                )}

                {application.creditFrozen && summaryInfoBoxDeclinedFrozen && (
                    <InfoBox type="info">{summaryInfoBoxDeclinedFrozen}</InfoBox>
                )}

                <div className="summary-declined__description">
                    {summaryTextDeclined1 && <p>{summaryTextDeclined1}</p>}
                    {summaryTextDeclined2 && <p>{summaryTextDeclined2}</p>}
                </div>

                {summaryInfoBoxDeclined && (
                    <InfoMessage
                        className="summary-declined__info-box"
                        text={summaryInfoBoxDeclined}
                        icon={IconTypes.LYSPAERE_24}
                    />
                )}

                {!!returnLink && (
                    <div className="summary-declined__button">
                        <Link href={returnLink} linkType={LinkType.BUTTON_STANDARD_POSITIVE}>
                            {summaryReturnButtonDeclined}
                        </Link>
                    </div>
                )}
            </>
        </div>
    );
};

export default SummaryDeclined;
